var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88557 5.4209H0.684204V15.263H3.88557V5.4209Z",
    fill: "#39373A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6056 5.53632C12.5716 5.52558 12.5394 5.51395 12.5036 5.50411C12.4607 5.49427 12.4177 5.48621 12.3739 5.47906C12.2039 5.44506 12.0178 5.4209 11.7995 5.4209C9.93305 5.4209 8.74931 6.77821 8.35921 7.30253V5.4209H5.15784V15.263H8.35921V9.89458C8.35921 9.89458 10.7786 6.525 11.7995 8.99985C11.7995 11.209 11.7995 15.263 11.7995 15.263H14.9999V8.62137C14.9999 7.13432 13.9808 5.89511 12.6056 5.53632Z",
    fill: "#39373A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24999 4.07884C3.11476 4.07884 3.81578 3.37782 3.81578 2.51306C3.81578 1.64829 3.11476 0.947266 2.24999 0.947266C1.38523 0.947266 0.684204 1.64829 0.684204 2.51306C0.684204 3.37782 1.38523 4.07884 2.24999 4.07884Z",
    fill: "#39373A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3158,
    height: 14.3158,
    fill: "white",
    transform: "translate(0.684204 0.947266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9a654ae92d33a2de353ac8dda8b138b2.svg";
export { ForwardRef as ReactComponent };